import {Component , OnInit} from '@angular/core';
import {CantonsService} from '../../../../core/services/cantons.service';
import {FuseConfigService} from '../../../../core/services/config.service';
import { EventService } from '../../../../core/services/event.service';

@Component({
    selector: 'event-cantons',
    templateUrl: './event-cantons.component.html',
    styleUrls: ['./event-cantons.component.scss'],
    standalone: false
})

export class EventCantonsComponent implements OnInit {

  cities = [];
  arrayOfCity = [];
  id;
  constructor (public cantonServive: CantonsService, public fuseConfig: FuseConfigService,
               public eventService: EventService) {
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnInit () {
    this.cantonServive.getCityForMergeTool().subscribe((res: any) => {
      this.cities = res;
      this.cantonServive.getMergeSettings().subscribe((setting: any) => {
        if (setting) {
          // console.log(setting);
          if (setting.listOfCity.length) {
            this.arrayOfCity = setting.listOfCity.split(',');
            // console.log(this.arrayOfCity);
          }
          if (setting.id) {
            this.id = setting.id;
          }
        }
      });
    });
  }

  toggle (event , id) {
    if (event.checked) {
      this.arrayOfCity.push(id.toString());
      // console.log(this.arrayOfCity);
      const numberArray = this.arrayOfCity.map(Number);
      this.cantonServive.addMergeSetting({id: this.id, listOfCity: numberArray.toString()}).subscribe();
    } else {
      const index = this.arrayOfCity.indexOf(id.toString());
      if (index !== -1) {
        this.arrayOfCity.splice(index , 1);
        // console.log(this.arrayOfCity);
        const numberArray = this.arrayOfCity.map(Number);
        this.cantonServive.addMergeSetting({id: this.id, listOfCity: numberArray.toString()}).subscribe();
      }
    }
  }

}
